'use client';

import React from 'react';

import clsx from 'clsx';

import styles from './styles.module.css';

import { Placeholder, PlaceHolderShape } from '@/components/Placeholder';
import { AspectRatio } from '@/components/ProductCard';
import {
  DEFAULT_ITEM_WIDTH,
  ScrollableItemRow,
} from '@/components/ScrollableItemRow';
import { useProductCardAspectRatio } from '@/modules/experiments/hooks/useProductCardAspectRatio';

type Props = {
  itemsPerRow: number;
  productsCount: number;
  pageXPadding?: number;
  minItemWidth?: number;
  className?: string;
  attributesClassName?: string;
  aspectRatio?: AspectRatio;
};

export function ModuleProductsSkeleton({
  itemsPerRow,
  pageXPadding,
  minItemWidth = DEFAULT_ITEM_WIDTH,
  productsCount,
  className,
  attributesClassName,
  aspectRatio: aspectRatioProp,
}: Props) {
  const { aspectRatio: experimentAspectRatio } = useProductCardAspectRatio();
  const aspectRatio = aspectRatioProp ?? experimentAspectRatio;

  return (
    <ScrollableItemRow
      itemsPerRow={itemsPerRow}
      pageXPadding={pageXPadding}
      minItemWidth={minItemWidth}
      className={className}
    >
      {Array.from({ length: productsCount }).map((_, index) => (
        <div
          key={index}
          className={styles.card}
          style={{ '--minWidth': `${minItemWidth}px` } as React.CSSProperties}
        >
          <Placeholder
            shape={PlaceHolderShape.RECTANGLE}
            width="100%"
            height="100%"
            className={clsx(styles.image, {
              [styles.isPortrait]: aspectRatio === AspectRatio.Portrait,
            })}
          />
          <Placeholder
            shape={PlaceHolderShape.RECTANGLE}
            width="64px"
            height="21px"
            className={clsx(styles.attributes, attributesClassName)}
          />
        </div>
      ))}
    </ScrollableItemRow>
  );
}
